export default __webpack_public_path__ + "assets/fonts/38778f81253085655aa242e270f72140.woff";